import { ERROR_ALERT, SUCCESS_ALERT, HIDE_ALERT, hideAlert } from '../actions/alert';
import { store } from '../store';

const DEFAULT_STATE = {
    type: '',
    text: '',
    id: 0
}

export default (state = DEFAULT_STATE, action) => {
    const id = new Date().getTime();

    function handleAlertAutoHide() {
        setTimeout(_ => {
            if (store.getState().alert.id === id) {
                store.dispatch(hideAlert());
            }
        }, 4000);
    }

    switch (action.type) {
        case ERROR_ALERT: {
            handleAlertAutoHide();
            return state = { type: 'danger', text: action.payload, id };
        }


        case SUCCESS_ALERT: {
            handleAlertAutoHide();
            return state = { type: 'success', text: action.payload, id };
        }

        case HIDE_ALERT:
            return state = { type: '', text: '', id: 0 };

        default: return state;
    }
}